import React from 'react';
import { HelperText } from "../Input/Input.styles";
import { FieldsetWrapper, Label } from "./FieldGroup.styles"; 

export interface FieldGroupProps extends React.HTMLAttributes<HTMLFieldSetElement> {
  title: string;
  children: React.ReactNode;
  name?: string; 
  error?: boolean; 
  helperText?: string;
  colorTitle?: string;
}

export const FieldGroup: React.FC<FieldGroupProps> = ({
  title,
  children,
  error,
  helperText,
  colorTitle,
  ...props
}) => {
  return (
    <FieldsetWrapper error={error} {...props}>
      {!!title && <Label color={colorTitle}>{title}</Label>}
      
      {children} 
      
      {!!helperText && (
        <HelperText 
          style={{ color: !error ? "#64748B" : "#F3322B", marginTop: '8px' }}
        >
          {helperText}
        </HelperText>
      )}
    </FieldsetWrapper>
  );
};